import { GenericCrudPage } from '@/components/GenericCrudPage';
import { paymentsConfig } from '@/pages/configs';

export default function PaymentsPage() {
  return <GenericCrudPage config={paymentsConfig} />;
}
